module.exports = __webpack_public_path__ + "img/bulogo.72a5c1c8.png";